module.exports = __webpack_public_path__ + "img/review-5.4c36b592.png";